<template>
    <div class="m-plans-my">
        <div class="m-my-item-plans">
            <h3 class="c-sidebar-right-title">
                <i class="u-icon u-icon-mycollection"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M337.009 493.087V61.038c0-10.446-8.468-18.913-18.914-18.913H53.955c-10.446 0-18.913 8.468-18.913 18.913v432.049c0 10.446 8.468 18.913 18.913 18.913h264.141c10.445 0 18.913-8.468 18.913-18.913z" fill="#ffc250"/><path d="M380.107 42.124h-63.299c10.446 0 18.914 8.468 18.914 18.913v432.049c0 10.446-8.468 18.913-18.914 18.913h63.299c10.446 0 18.914-8.468 18.914-18.913V61.038c0-10.446-8.468-18.914-18.914-18.914z" fill="#eab14d"/><path d="M65.955 474.326V79.798a6.76 6.76 0 016.76-6.76h288.632a6.76 6.76 0 016.76 6.76v394.528a6.76 6.76 0 01-6.76 6.76H72.715a6.76 6.76 0 01-6.76-6.76z" fill="#f5f5f5"/><path d="M361.347 73.038h-63.299a6.76 6.76 0 016.76 6.76v394.528a6.76 6.76 0 01-6.76 6.76h63.299a6.76 6.76 0 006.76-6.76V79.798a6.76 6.76 0 00-6.76-6.76z" fill="#eaeaea"/><path d="M257.21 23.538v-9.957c0-7.5-6.08-13.581-13.581-13.581h-53.197c-7.501 0-13.581 6.081-13.581 13.581v9.957a5.554 5.554 0 01-5.554 5.554h-22.14c-7.365 0-13.336 5.971-13.336 13.336v30.61H298.24v-30.61c0-7.365-5.971-13.336-13.336-13.336h-22.14a5.554 5.554 0 01-5.554-5.554z" fill="#c2d0da"/><g><g fill="#66b49d"><path d="M105.278 182.792v-59.538c0-6.596 5.348-11.944 11.944-11.944h59.538c6.596 0 11.944 5.348 11.944 11.944v59.538c0 6.596-5.348 11.944-11.944 11.944h-59.538c-6.597 0-11.944-5.348-11.944-11.944zM105.278 306.832v-59.538c0-6.596 5.348-11.944 11.944-11.944h59.538c6.596 0 11.944 5.348 11.944 11.944v59.538c0 6.596-5.348 11.944-11.944 11.944h-59.538c-6.597 0-11.944-5.348-11.944-11.944zM105.278 430.871v-59.538c0-6.596 5.348-11.944 11.944-11.944h59.538c6.596 0 11.944 5.348 11.944 11.944v59.538c0 6.596-5.348 11.944-11.944 11.944h-59.538c-6.597 0-11.944-5.347-11.944-11.944z"/></g><path d="M141.951 174.344h-.026a10.778 10.778 0 01-8.655-4.417l-9.022-12.39a7.727 7.727 0 0112.492-9.097l5.231 7.185 15.295-20.78a7.726 7.726 0 0110.802-1.642 7.726 7.726 0 011.642 10.803l-19.112 25.965a10.773 10.773 0 01-8.647 4.373zM141.95 301.083h-.028a10.774 10.774 0 01-8.654-4.419l-9.02-12.388a7.727 7.727 0 0112.492-9.097l5.231 7.185 15.295-20.78a7.727 7.727 0 0112.444 9.161l-19.112 25.965a10.768 10.768 0 01-8.648 4.373zM141.95 422.425l-.026-.001a10.777 10.777 0 01-8.654-4.415l-9.022-12.392a7.726 7.726 0 1112.493-9.095l5.23 7.184 15.296-20.78a7.727 7.727 0 0112.444 9.161l-19.112 25.965a10.778 10.778 0 01-8.649 4.373z" fill="#f6f9f9"/></g><g><path d="M322.692 144.605h-95.515a7.726 7.726 0 110-15.452h95.515a7.726 7.726 0 110 15.452zM274.935 176.892h-47.757a7.726 7.726 0 110-15.452h47.757a7.726 7.726 0 110 15.452z" fill="#ddeafb"/></g><g><path d="M291.264 268.645h-64.086a7.726 7.726 0 110-15.452h64.086a7.726 7.726 0 110 15.452zM274.935 300.932h-47.757a7.726 7.726 0 110-15.452h47.757a7.726 7.726 0 110 15.452z" fill="#ddeafb"/></g><g><path d="M446.91 201.718l-7.586-9.994-28.385-17.975-10.911-1.719-145.345 229.673a59.825 59.825 0 00-7.616 17.987 46.82 46.82 0 0141.494 26.276 59.821 59.821 0 0013.004-14.575z" fill="#fc8086"/><path d="M467.43 130.992l-12.265-7.767c-9.561-6.055-22.221-3.21-28.273 6.353l-11.247 17.773 3.588 7.233 34.13 21.613 9.165.842 11.254-17.784c6.048-9.558 3.205-22.211-6.352-28.263z" fill="#8c9ba6"/><path d="M400.044 171.964l15.625-24.678 46.89 29.688-15.624 24.678z" fill="#c9e2e7"/><path d="M288.561 445.967l-41.385 33.35c-5.838 4.705-14.32-.666-12.563-7.955l12.454-51.671a46.816 46.816 0 0141.494 26.276z" fill="#7c8b96"/><path d="M277.706 431.649l152.359-240.598-13.055-8.267-152.359 240.598a46.834 46.834 0 0113.055 8.267z" fill="#fb636f"/></g></svg></i>
                <span>我的清单</span>
                <a class="fr el-button el-button--success el-button--mini" @click="onAddPlan" v-if="isLogin">
                    <i class="el-icon-document-add"></i>
                    <span>创建</span>
                </a>
            </h3>
            <template v-if="isLogin">
                <template v-if="data && data.length">
                    <router-link
                        class="m-my-item-plan"
                        v-for="(plan, key) in data"
                        :key="key"
                        :to="{
                            name: 'plan_view',
                            params: { plan_id: plan.id },
                        }"
                    >
                        <h5 class="u-title">
                            <i class="el-icon-lock" v-if="!plan.public"></i>
                            <span>{{ plan.title }}</span>
                        </h5>
                        <!-- <div class="u-misc">
                            <div class="u-delete" @click.stop="delete_plan($event, plan.id)">
                                <i class="el-icon-delete " title="删除"></i>
                            </div>
                            <div class="u-edit" @click.stop="edit_plan($event, plan.id)">
                                <i class="el-icon-edit " title="编辑"></i>
                            </div>
                            <span class="u-updated">编辑于{{ date_format(plan.updated) }}</span>
                        </div> -->
                    </router-link>
                    <el-pagination
                        class="m-pagination"
                        background
                        layout="prev, pager, next"
                        :pager-count="5"
                        small
                        :hide-on-single-page="true"
                        :page-size="per"
                        :total="total"
                        :current-page.sync="page"
                    ></el-pagination>
                </template>
                <div v-else class="u-tip"><i class="el-icon-warning-outline"></i> 暂无物品清单记录</div>
            </template>
            <template v-else
                ><div class="u-tip"><i class="el-icon-warning-outline"></i> 请先进行登录</div></template
            >
        </div>
    </div>
</template>

<script>
import { getMyPlans, addMyPlan } from "@/service/item-plan.js";
import { __Links } from "@jx3box/jx3box-common/data/jx3box.json";
import User from "@jx3box/jx3box-common/js/user";
import { date_format } from "@/filters";
import bus from "@/store/bus";
export default {
    name: "",
    props: [],
    data: function () {
        return {
            isLogin: User.isLogin(),
            data: [],

            page: 1,
            per: 8,
            total: 0,
        };
    },
    computed: {
        params: function () {
            return {
                page: this.page,
                per: this.per,
            };
        },
    },
    watch: {
        params: {
            deep: true,
            immediate: true,
            handler() {
                this.loadData();
            },
        },
    },
    mounted() {
        bus.on('plan_list_refresh', () => {
            this.loadData();
        })
    },
    methods: {
        date_format,
        loadData() {
            if (!this.isLogin) {
                return;
            }
            getMyPlans(this.params).then((res) => {
                this.data = res.list;
                this.total = res.total;
            });
        },
        onAddPlan() {
            this.$prompt("请输入清单名称", "创建清单", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPlaceholder: "请输入清单名称",
                inputValidator: (value) => {
                    if (!value) {
                        return "请输入清单名称";
                    }
                },
                callback: (action, instance) => {
                    if (action === "confirm") {
                        const data = {
                            title: instance.inputValue,
                            type: 1, // 1: 物品清单
                            public: 1,
                            relation: [],
                            description: "",
                        }
                        addMyPlan(data).then((res) => {
                            this.$message({
                                message: "创建成功",
                                type: "success",
                            });
                            this.data.unshift(res.data.data);
                            this.$router.push({
                                name: "plan_edit",
                                params: { plan_id: res.data.data.id },
                            });
                        });
                    }
                },
            })
        }
    },
};
</script>
